import { render, staticRenderFns } from "./TestGrid.vue?vue&type=template&id=16299c76&scoped=true&"
import script from "./TestGrid.vue?vue&type=script&lang=js&"
export * from "./TestGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16299c76",
  null
  
)

export default component.exports